var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.929077 7.1665H3.17908V4.9165H0.929077V7.1665ZM0.929077 11.6665H3.17908V9.4165H0.929077V11.6665ZM0.929077 2.6665H3.17908V0.416504H0.929077V2.6665ZM5.42908 7.1665H21.1791V4.9165H5.42908V7.1665ZM5.42908 11.6665H21.1791V9.4165H5.42908V11.6665ZM5.42908 0.416504V2.6665H21.1791V0.416504H5.42908ZM0.929077 7.1665H3.17908V4.9165H0.929077V7.1665ZM0.929077 11.6665H3.17908V9.4165H0.929077V11.6665ZM0.929077 2.6665H3.17908V0.416504H0.929077V2.6665ZM5.42908 7.1665H21.1791V4.9165H5.42908V7.1665ZM5.42908 11.6665H21.1791V9.4165H5.42908V11.6665ZM5.42908 0.416504V2.6665H21.1791V0.416504H5.42908Z",
    fill: "#78A22F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListActive);
export default __webpack_public_path__ + "static/media/list-active.b50238063aa10f7e37c1f1c9eaa69e81.svg";
export { ForwardRef as ReactComponent };